angular
    .module("skillBuilderSaaS")
    .directive("convertToNumber", function () {
    return {
        require: "ngModel",
        link: function (_scope, _element, _attrs, ngModel) {
            ngModel.$parsers.push(function (val) {
                return parseInt(val, 10);
            });
            ngModel.$formatters.push(function (val) {
                return "" + val;
            });
        }
    };
});
